import { render, staticRenderFns } from "./SzvmDocumentsList.vue?vue&type=template&id=386b6bd6&"
import script from "./SzvmDocumentsList.vue?vue&type=script&lang=js&"
export * from "./SzvmDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./SzvmDocumentsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports